import { ReactNode } from 'react';
import { clsx } from 'clsx';
import type { WidgetSize } from '../../types';

interface WidgetWrapperProps {
  size: WidgetSize;
  children: ReactNode;
}

// Wrapper pour chaque widget avec la taille appropriée
export function WidgetWrapper({ size, children }: WidgetWrapperProps) {
  return (
    <div
      className={clsx(
        // Sur mobile : toujours pleine largeur
        'col-span-4',
        // Sur tablette : small = 2 colonnes, medium/large = 4 colonnes
        size === 'small' ? 'md:col-span-2' : 'md:col-span-4',
        // Sur desktop : small = 1 colonne, medium = 2 colonnes, large = 4 colonnes
        size === 'small' && 'lg:col-span-1',
        size === 'medium' && 'lg:col-span-2',
        size === 'large' && 'lg:col-span-4'
      )}
    >
      {children}
    </div>
  );
}

interface WidgetGridProps {
  children: ReactNode;
}

// Grille principale qui contient les widgets
export default function WidgetGrid({ children }: WidgetGridProps) {
  return (
    <div className="grid grid-cols-4 gap-4 lg:gap-6">
      {children}
    </div>
  );
}
